import * as React from 'react';
import { SVGProps } from 'react';

const FileIconVsdSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={24} height={28} rx={2} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.591 14.5H5v8h2.088a3 3 0 0 0 5.917 0H19v-8h-2.408l-2.5-2.5-2.5 2.5Zm4.322.735-1.821 1.821-1.821-1.82 1.82-1.822 1.822 1.821Zm1.414 0-3.235 3.236-2.97-2.97H6v6h1.088a3 3 0 0 1 5.917 0H18v-6h-.937l.264-.265Zm-5.866 5.35a2 2 0 1 0-2.829 2.829 2 2 0 0 0 2.829-2.828Z"
      fill="#DADDE1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 8.77c-.22.153-.487.23-.8.23h-.5c-.587 0-1.017-.123-1.29-.37-.273-.253-.41-.663-.41-1.23V5.6c0-.56.137-.967.41-1.22.28-.253.77-.38 1.35-.38H15V2h1v7h-1v-.23ZM14.35 8c.22 0 .383-.057.49-.17a.565.565 0 0 0 .16-.38V5h-1.25c-.247 0-.433.057-.56.17-.127.113-.19.273-.19.48v1.7c0 .207.063.367.19.48.127.113.313.17.56.17h.6Z"
      fill="#fff"
    />
    <path
      d="M5 4H4v3l1 2h1l1-2V4H6v3H5V4ZM17 9h1V7.5l1-.5 1 .5V9h1V7h-1V6h1V4h-1v1.5L19 6l-1-.5V4h-1v2h1v1h-1v2ZM11 7.75c0 .42-.13.733-.39.94-.253.207-.623.31-1.11.31H8V8h1.45c.18 0 .317-.037.41-.11a.423.423 0 0 0 .14-.34v-.1c0-.3-.143-.45-.43-.45H9.2c-.467 0-.667-.1-.9-.3-.227-.207-.3-.53-.3-.97v-.47c0-.447.087-.767.34-.96.253-.2.667-.3 1.16-.3H11v1H9.55c-.167 0-.3.04-.4.12-.1.073-.15.183-.15.33v.11c0 .153.043.267.13.34.093.073.21.1.35.1h.15c.447 0 .787.12 1.02.34.233.213.35.533.35.96v.45Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconVsdSizeS;
